export default __webpack_public_path__ + "static/media/pdfIcon.ba4a9de7.svg";